import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { MensagemHistorico } from "../typings";

function useHistoricoMensagem(mensagemId: string, enabled = false) {
  return useQuery(`/v1/mensagem/${mensagemId}/historico`, async () => {
    const { data } = await http.get<PaginateResult<MensagemHistorico>>(
      `/v1/mensagem/${mensagemId}/historico`,
      {
        params: {
          page: 1,
          limit: 9999,
        },
      }
    );
    return data;
  }, {enabled});
}

export default useHistoricoMensagem;
